<template>
  <GridBase technology>
    <section class="top">
      <h2>
        <TextBlock file="tech/t1" class="pre-line" />
      </h2>
    </section>
    <section class="sec1 j" data-offset="0">
      <PrSplit class="v1" type="type0" img="/img/tech/bg-tech.jpg">
        <div class="title-wrap">
          <TextBlock file="tech/t2" class="pre-line title" />
          <TextBlock file="tech/t3" class="pre-line desc" />
        </div>
      </PrSplit>
    </section>
    <section class="sec2">
      <div class="wrap" v-if="this.sect === 'sm'">
        <div class="copy">
          <div class="title">
            <button class="item is-active">
              <h3>
                Safety first
              </h3>
            </button>
            <button class="item is-active">
              <h3>
                flexible and efficient
              </h3>
            </button>
            <button class="item is-active">
              <h3>
                in an eco-friendly way
              </h3>
            </button>
          </div>
          <div class="text">
            <ul class="list">
              <li class="item" v-for="(item) in f1.list" :key="item.subTitle">
                <p class="sub-title" v-html="item.subTitle" />
                <p class="desc" v-html="item.desc" />
              </li>
            </ul>
          </div>
        </div>
        <div class="scroll">
          <card-item class="area1" ref="area1">
            <div class="inner" v-for="(item) in f2.list" :key="item.subTitle">
              <div class="text mo">
                <p class="sub-title" v-html="item.subTitle" />
                <p class="desc" v-html="item.desc" />
              </div>
              <ul class="list">
                <li class="item" v-for="(item) in item.list" :key="item.title"
                  :style="{ backgroundImage: `url(${item.img})` }">
                  <p class="title" v-html="item.title" />
                  <button type="button" class="btn-more">more</button>
                  <div class="exp">
                    <p class="text" v-html="item.text" />
                    <p class="name" v-html="item.name" />
                  </div>
                </li>
              </ul>
            </div>
          </card-item>
          <card-item class="area2" ref="area2">
            <div class="inner" v-for="(item) in f3.list" :key="item.subTitle">
              <div class="text mo">
                <p class="sub-title" v-html="item.subTitle" />
                <p class="desc" v-html="item.desc" />
              </div>
              <ul class="list">
                <li class="item" v-for="(item) in item.list" :key="item.title"
                  :style="{ backgroundImage: `url(${item.img})` }">
                  <p class="title" v-html="item.title" />
                  <button type="button" class="btn-more">more</button>
                  <div class="exp">
                    <p class="text" v-html="item.text" />
                    <p class="name" v-html="item.name" />
                  </div>
                </li>
              </ul>
            </div>
          </card-item>
          <card-item class="area3" ref="area3">
            <div class="inner" v-for="(item) in f4.list" :key="item.subTitle">
              <div class="text mo">
                <p class="sub-title" v-html="item.subTitle" />
                <p class="desc" v-html="item.desc" />
              </div>
              <ul class="list">
                <li class="item" v-for="(item) in item.list" :key="item.title"
                  :style="{ backgroundImage: `url(${item.img})` }">
                  <p class="title" v-html="item.title" />
                  <button type="button" class="btn-more">more</button>
                  <div class="exp">
                    <p class="text" v-html="item.text" />
                    <p class="name" v-html="item.name" />
                  </div>
                </li>
              </ul>
            </div>
          </card-item>
        </div>
      </div>
      <ContentSticky id="sec2" class="j" v-else data-offset="0" @fixed="sticky">
        <div class="wrap">
          <div class="copy">
            <div class="title">
              <button class="item" @click="scrollMove('area1')">
                <h3>
                  Safety first
                </h3>
              </button>
              <button class="item" @click="scrollMove('area2')">
                <h3>
                  flexible and efficient
                </h3>
              </button>
              <button class="item" @click="scrollMove('area3')">
                <h3>
                  in an eco-friendly way
                </h3>
              </button>
            </div>
            <div class="text">
              <ul class="list">
                <li class="item" v-for="(item) in f1.list" :key="item.subTitle">
                  <p class="sub-title" v-html="item.subTitle" />
                  <p class="desc" v-html="item.desc" />
                </li>
              </ul>
            </div>
          </div>
          <div class="scroll">
            <card-item class="area1" ref="area1">
              <div class="inner" v-for="(item) in f2.list" :key="item.subTitle">
                <div class="text mo">
                  <p class="sub-title" v-html="item.subTitle" />
                  <p class="desc" v-html="item.desc" />
                </div>
                <ul class="list">
                  <li class="item" v-for="(item) in item.list" :key="item.title"
                    :style="{ backgroundImage: `url(${item.img})` }">
                    <p class="title" v-html="item.title" />
                    <button type="button" class="btn-more">more</button>
                    <div class="exp">
                      <p class="text" v-html="item.text" />
                      <p class="name" v-html="item.name" />
                    </div>
                  </li>
                </ul>
              </div>
            </card-item>
            <card-item class="area2" ref="area2">
              <div class="inner" v-for="(item) in f3.list" :key="item.subTitle">
                <div class="text mo">
                  <p class="sub-title" v-html="item.subTitle" />
                  <p class="desc" v-html="item.desc" />
                </div>
                <ul class="list">
                  <li class="item" v-for="(item) in item.list" :key="item.title"
                    :style="{ backgroundImage: `url(${item.img})` }">
                    <p class="title" v-html="item.title" />
                    <button type="button" class="btn-more">more</button>
                    <div class="exp">
                      <p class="text" v-html="item.text" />
                      <p class="name" v-html="item.name" />
                    </div>
                  </li>
                </ul>
              </div>
            </card-item>
            <card-item class="area3" ref="area3">
              <div class="inner" v-for="(item) in f4.list" :key="item.subTitle">
                <div class="text mo">
                  <p class="sub-title" v-html="item.subTitle" />
                  <p class="desc" v-html="item.desc" />
                </div>
                <ul class="list">
                  <li class="item" v-for="(item) in item.list" :key="item.title"
                    :style="{ backgroundImage: `url(${item.img})` }">
                    <p class="title" v-html="item.title" />
                    <button type="button" class="btn-more">more</button>
                    <div class="exp">
                      <p class="text" v-html="item.text" />
                      <p class="name" v-html="item.name" />
                    </div>
                  </li>
                </ul>
              </div>
            </card-item>
          </div>
        </div>
      </ContentSticky>
    </section>
    <section class="sec3">
      <PrSplit class="v3" type="type0">
        <div class="title-wrap">
          <TextBlock file="tech/t6" class="pre-line title" />
        </div>
      </PrSplit>
    </section>
    <section class="sec4">
      <PrSplit class="v4" type="type0">
        <div class="wrap">
          <div class="img-box">
            <div class="img"></div>
          </div>
          <div class="copy">
            <div class="title">
              <TextBlock file="tech/t7" class="pre-line title-text" />
            </div>
            <div class="desc">
              <TextBlock file="tech/t8" class="pre-line desc-text" />
            </div>
          </div>
        </div>
      </PrSplit>
    </section>
    <section class="sec5">
      <h3 class="sec-title">Risk management and response solutions <br class="hidden-sm-down" />for service continuity
      </h3>
      <div class="feature-body">
        <div class="hidden-lg-up">
          <div v-for="(item, idx) in f5.list" :key="item.title" class="list-item m-item" ontouchstart
            @click="showPopupF5(idx)">
            <div class="title" v-html="item.title" />
          </div>
        </div>
        <slider @click="resetF5" class="hidden-md-down" :option="{ slidesPerView: 'auto', loop: false, spaceBetween: 40 }"
          :pagination="false" :class="`active-${f5Active}`" ref="f5slide">
          <div v-for="(item, idx) in f5.list" :key="item.title" :style="{ backgroundImage: `url(${item.img})` }"
            class="item swiper-slide" :class="`item-${idx}`" :data-click="idx">
            <div class="title" v-html="item.title" />
            <div class="exp">
              <p v-html="item.body" />
              <p v-if="item.name" class="name" v-html="item.name" />
            </div>
          </div>
        </slider>
      </div>
      <div class="cont">
        <div class="copy">
          <TextBlock file="tech/t9" class="pre-line title" />
          <TextBlock file="tech/t10" class="pre-line desc" />
        </div>
        <div class="image">
          <img src="/img/tech/cont.jpg" alt="">
        </div>
      </div>
    </section>
    <article class="bottom">
      <GridBase b50>
        <TextBlock file="tech/t-bottom" class="q pre-line" />
      </GridBase>
      <quick-link>
        <quick-link-item><router-link to="../gak/gak-sejong">GAK Sejong</router-link></quick-link-item>
      </quick-link>
    </article>
  </GridBase>
</template>
<script>
import GridBase from '@/views/components/GridBase';
import QuickLink from '@/views/components/QuickLink';
import QuickLinkItem from '@/views/components/QuickLinkItem';
import feature from "@/data/gak/technologyFeatureEN";
import CardItem from '@/views/components/CardItem.vue';
import TextBlock from '@/views/components/TextBlock';
import PrSplit from "@/views/components/PrSplit";
import Slider from "@/views/components/Slider";
import ContentSticky from '@/views/components/ContentSticky';
import { getOffsetLeft } from "@/utils";
import responsive from "@/utils/responsive";

export default {
  name: 'technology',
  components: { TextBlock, QuickLinkItem, QuickLink, GridBase, PrSplit, Slider, CardItem, ContentSticky },
  data() {
    return {
      f4Active: -1,
      f5Active: -1,
      feature,
      f1: feature[0],
      f2: feature[1],
      f3: feature[2],
      f4: feature[3],
      f5: feature[4],
      preScrollTop: 0,
      space: 0,
      resize: false
    }
  },
  mounted() {
    this.setElement();
    responsive.addListener(this.resized);
  },
  beforeDestroy() {
    responsive.removeListener(this.resized);
    window.removeEventListener('scroll', this.scrollMoveActive);
  },
  methods: {
    setElement() {
      this.header = document.querySelector('header .bar');
      this.sec2 = document.querySelector('.sec2');
      this.sec2Content = this.sec2.querySelector('.j');
      this.scroll = this.sec2.querySelector('.scroll');
      this.itemTitle = this.sec2.querySelectorAll('.copy .title .item');
      this.itemText = this.sec2.querySelectorAll('.copy .text .item');
      this.text1 = this.itemText[0];
      this.text2 = this.itemText[1];
      this.text3 = this.itemText[2];
      this.text4 = this.itemText[3];
      this.text5 = this.itemText[4];
      this.text6 = this.itemText[5];
      this.area1 = this.sec2.querySelector('.scroll .area1');
      this.area2 = this.sec2.querySelector('.scroll .area2');
      this.area3 = this.sec2.querySelector('.scroll .area3');
      this.area1Inner = this.sec2.querySelectorAll('.scroll .area1 .inner');
      this.area2Inner = this.sec2.querySelectorAll('.scroll .area2 .inner');
      this.area3Inner = this.sec2.querySelectorAll('.scroll .area3 .inner');
    },
    setElementSticky() {
      this.stickContainer = document.querySelector('.stick-container');
      this.stickCover = this.stickContainer.querySelector('.cover');
      this.stickScroll = this.stickContainer.querySelector('.scroll');
      this.stickSec2 = this.stickContainer.querySelector('.stick-container #sec2');
      this.copy = this.stickSec2.querySelector('.copy');
      this.itemTitle = this.stickSec2.querySelectorAll('.copy .title .item');
      this.itemText = this.stickSec2.querySelectorAll('.copy .text .item');
      this.text1 = this.itemText[0];
      this.text2 = this.itemText[1];
      this.text3 = this.itemText[2];
      this.text4 = this.itemText[3];
      this.text5 = this.itemText[4];
      this.text6 = this.itemText[5];
      this.area1 = this.stickSec2.querySelector('.scroll .area1');
      this.area2 = this.stickSec2.querySelector('.scroll .area2');
      this.area3 = this.stickSec2.querySelector('.scroll .area3');
      this.area1Inner = this.stickSec2.querySelectorAll('.scroll .area1 .inner');
      this.area2Inner = this.stickSec2.querySelectorAll('.scroll .area2 .inner');
      this.area3Inner = this.stickSec2.querySelectorAll('.scroll .area3 .inner');
    },
    sticky(init) {
      if (init) {
        this.setElementSticky();
        this.copyFixed();
        responsive.addListener(this.resized);

        if (this.resize) {
          this.copyFixed();
        }
      } else {
        this.copyFixedReset();
      }
    },
    showPopupF5(idx) {
      this.$store.commit("setChuncheonPopup", {
        type: "type-02",
        idx,
        info: this.f5,
      });
    },
    resetF5(idx, el) {
      this.f5Active = idx;
      const right =
        getOffsetLeft(el) +
        +el.parentNode.style.transform.match(/(-?\d+)px/)[1] +
        el.offsetWidth;
      if (right > window.innerWidth) this.$refs.f5slide.next();
    },
    scrollMove(refName) {
      this.$refs[refName].$el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollMoveActive() {
      const area1Top = -Math.floor(this.area1.getBoundingClientRect().top);
      const area1Height = Math.floor(this.area1.getBoundingClientRect().height);
      const area2Top = -Math.floor(this.area2.getBoundingClientRect().top);
      const area2Height = Math.floor(this.area2.getBoundingClientRect().height);
      let n;

      if (area1Top <= area1Height - this.space) {
        // area1 영역
        n = 0;
        // copy text 연동

        this.copyText1Active();
      } else if (area2Top <= area2Height - this.space) {
        // area2 영역
        n = 1;

        // copy text 연동
        this.copyText2Active();
      } else {
        // area3 영역
        n = 2;

        // copy text 연동
        this.copyText3Active();
      }

      this.itemTitle.forEach(function (el) {
        el.classList.remove('is-active');
      })
      this.itemTitle[n].classList.add('is-active');
    },
    copyText1Active() {
      const inner1Top = -Math.floor(this.area1Inner[0].getBoundingClientRect().top);
      const inner1Height = Math.floor(this.area1Inner[0].getBoundingClientRect().height);
      const inner2Top = -Math.floor(this.area1Inner[1].getBoundingClientRect().top)
      const inner2Height = Math.floor(this.area1Inner[1].getBoundingClientRect().height)
      let nextScrollTop = window.scrollY;

      if (this.preScrollTop < nextScrollTop) {
        // scroll down

        if (inner1Top <= inner1Height - this.space) {
          // inner1
          this.text1.classList.add('is-active');

        } else if (inner2Top <= inner2Height - this.space) {
          // inner2
          this.text1.classList.add('is-hide');
          this.text1.classList.remove('is-active');
          this.text2.classList.remove('is-hide');
          this.text2.classList.add('is-active');
        }
      } else {
        // scroll up
        this.itemText.forEach(function (el) {
          el.classList.remove('is-hide');
        })

        if (inner1Top <= inner1Height) {
          // inner1
          this.text1.classList.remove('is-hide');
          this.text1.classList.add('is-active');
          this.text2.classList.add('is-hide');
          this.text2.classList.remove('is-active');
        } else if (inner2Top <= inner2Height) {
          // inner2
          this.text2.classList.remove('is-hide');
          this.text2.classList.add('is-active');
          this.text3.classList.add('is-hide');
          this.text3.classList.remove('is-active');
        }
      }
      this.preScrollTop = nextScrollTop;
    },
    copyText2Active() {
      const inner3Top = -Math.floor(this.area2Inner[0].getBoundingClientRect().top);
      const inner3Height = Math.floor(this.area2Inner[0].getBoundingClientRect().height);
      const inner4Top = -Math.floor(this.area2Inner[1].getBoundingClientRect().top);
      const inner4Height = Math.floor(this.area2Inner[1].getBoundingClientRect().height);
      let nextScrollTop = window.scrollY;

      if (this.preScrollTop < nextScrollTop) {
        // scroll down

        if (inner3Top <= inner3Height - this.space) {
          // inner3
          this.text2.classList.add('is-hide');
          this.text2.classList.remove('is-active');
          this.text3.classList.remove('is-hide');
          this.text3.classList.add('is-active');

        } else if (inner4Top <= inner4Height - this.space) {
          // inner4
          this.text3.classList.add('is-hide');
          this.text3.classList.remove('is-active');
          this.text4.classList.remove('is-hide');
          this.text4.classList.add('is-active');
        }
      } else {
        // scroll up
        this.itemText.forEach(function (el) {
          el.classList.remove('is-hide');
        })

        if (inner3Top <= inner3Height) {
          // inner3
          this.text4.classList.add('is-hide');
          this.text3.classList.remove('is-hide');
          this.text3.classList.add('is-active');
          this.text4.classList.remove('is-active');
        } else if (inner4Top <= inner4Height) {
          // inner4
          this.text5.classList.add('is-hide');
          this.text5.classList.remove('is-active');
          this.text4.classList.remove('is-hide');
          this.text4.classList.add('is-active');
        }
      }
      this.preScrollTop = nextScrollTop;
    },
    copyText3Active() {
      const inner5Top = -Math.floor(this.area3Inner[0].getBoundingClientRect().top);
      const inner5Height = Math.floor(this.area3Inner[0].getBoundingClientRect().height);
      const inner6Top = -Math.floor(this.area3Inner[1].getBoundingClientRect().top);
      const inner6Height = Math.floor(this.area3Inner[1].getBoundingClientRect().height);
      let nextScrollTop = window.scrollY;

      if (this.preScrollTop < nextScrollTop) {
        // scroll down

        if (inner5Top <= inner5Height - this.space) {
          // inner5
          this.text4.classList.add('is-hide');
          this.text4.classList.remove('is-active');
          this.text5.classList.remove('is-hide');
          this.text5.classList.add('is-active');

        } else if (inner6Top <= inner6Height - this.space) {
          // inner6
          this.text5.classList.add('is-hide');
          this.text5.classList.remove('is-active');
          this.text6.classList.remove('is-hide');
          this.text6.classList.add('is-active');
        }
      } else {
        // scroll up
        this.itemText.forEach(function (el) {
          el.classList.remove('is-hide');
        })

        if (inner5Top <= inner5Height) {
          // inner5
          this.text6.classList.add('is-hide');
          this.text6.classList.remove('is-active');
          this.text5.classList.remove('is-hide');
          this.text5.classList.add('is-active');

        }
      }
      this.preScrollTop = nextScrollTop;
    },
    setStickyHeight() {
      const coverEl = document.querySelector('.cover');
      const sec2Content = document.querySelector('.sec2 .j');

      if (coverEl !== null) {
        const coverElHeight = coverEl.offsetHeight;
        sec2Content.style.height = coverElHeight + 'px';
      }
    },
    copyFixed() {
      this.copy.classList.add('is-fixed');
    },
    copyFixedReset() {
      this.copy.classList.remove('is-fixed');
    },
    resized(section) {
      if (section.section !== 'sm') {
        this.setStickyHeight();

        const headerHeight = this.header.offsetHeight;
        this.space = headerHeight * 2;
        this.resize = true;
        window.addEventListener('scroll', this.scrollMoveActive);

        if (section.section === 'xxl') {
          this.space = 250;
        }
      }
    },
  },
};
</script>
